var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-activity-introduce-wrapper"},[_c('div',{staticClass:"title"},[(_vm.titleImg)?_c('img',{staticClass:"img-title tag",attrs:{"src":_vm.titleImg}}):_vm._e()]),_c('div',{staticClass:"content"},[_vm._v(" "+_vm._s(_vm.content)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }